import React from 'react';
import AddressBase from './AddressBase';
import Input from 'components/Input';
import SameLine from 'components/widget/SameLine';

export default class DefaultAddress extends AddressBase {
  state = {
    houseNo: null,
    houseName: null,
    address: null,
    town: null,
    county: null,
    postcode: null
  };

  formValid = () => (!!this.state.houseNo || !!this.state.houseName) && !!this.state.address && !!this.state.town;

  render() {
    return (
      <div>
        <SameLine>
          <Input
            name="houseNo"
            label="House no"
            className="smaller"
            value={this.state.houseNo || ''}
            onChange={this.handleChange}
          />

          <Input
            name="houseName"
            label="House name"
            placeholder={(this.state.houseNo) ? 'Optional' : 'Required'}
            value={this.state.houseName || ''}
            onChange={this.handleChange}
          />
        </SameLine>

        <Input
          name="address"
          label="Address"
          placeholder="Required"
          value={this.state.address || ''}
          onChange={this.handleChange}
        />

        <Input
          name="town"
          label="Town/city"
          placeholder="Required"
          value={this.state.town || ''}
          onChange={this.handleChange}
        />

        <Input
          name="county"
          label="County"
          placeholder="Optional"
          value={this.state.county || ''}
          onChange={this.handleChange}
        />

        <Input
          name="postcode"
          label="Postal code"
          placeholder="Optional"
          value={this.state.postcode || ''}
          onChange={this.handleChange}
          error={this.props.errors && this.props.errors.postcode}
        />
      </div>
    );
  }
}
